import React, { forwardRef, DOMAttributes } from 'react';

import shouldForwardProp from '@styled-system/should-forward-prop';
import styled from '@emotion/styled';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  compose,
  variant,
  DisplayProps,
  display
} from '@lucid/theme';

export type BoxTags = 'div' | 'section' | 'main' | 'aside' | 'article' | 'header' | 'footer';

export interface BoxProps
  extends BackgroundProps,
    BorderProps,
    ShadowProps,
    SpaceProps,
    ColorProps,
    FlexboxProps,
    GridProps,
    LayoutProps,
    PositionProps,
    DisplayProps,
    DOMAttributes<Element> {
      /** Sets the HTML tag for the Box Component. */
      as?: BoxTags;
      /** Allows the component to get additional styles. */
      className?: string;
      /** HTML id for Box Component. */
      id?: string;
      /** Sets the role for the Box Component. */
      role?: string;
      /** Sets the tabIndex for the Box Component. */
      tabIndex?: number;
}

const boxStyleProps = compose(
  background,
  shadow,
  border,
  color,
  grid,
  space,
  flexbox,
  layout,
  position,
  display
);

const StyledBox = styled('div',
  {
    shouldForwardProp
  }
)(
  variant({
    variants: {
      defaultVariant: {}
    }
  }),
  boxStyleProps
);

const Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ className, ...rest }, forwardedRef) => (
    <StyledBox ref={forwardedRef} {...rest} className={className} />
  )
);

export { Box };
export default Box;
